import React from 'react';
import { QshalaVarsityFinanceQuiz } from '../views';

const AccountGeneralPage = () => {
  return <QshalaVarsityFinanceQuiz/>;
};

export default AccountGeneralPage;